import React from "react";
import { Zoom } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { DIALOG_ANIMATIONS } from "../utils/constants";

const ZoomTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return (
    <Zoom
      ref={ref}
      {...props}
      timeout={{
        enter: DIALOG_ANIMATIONS.ENTER_DURATION,
        exit: DIALOG_ANIMATIONS.EXIT_DURATION
      }}
    />
  );
});

export default ZoomTransition;
